// A part of a store's shopping assistant pointed at with Select in the storefront canvas: what the preview frame
// reports (untrusted page data, bounded). Pure, so the composer's chips can use it too.
import type { StorefrontSelection } from '../types';

const text = (value: unknown, max: number) =>
  typeof value === 'string' && value.trim() && value.length <= max ? value.trim() : undefined;
/** What the preview frame reports with Select (untrusted page data), bounded; null when it is not a part. */
export function readStorefrontSelection(store: string, value: unknown): StorefrontSelection | null {
  if (!value || typeof value !== 'object') return null;
  const report = value as Record<string, unknown>;
  const part = text(report.part, 40);
  const tag = text(report.tag, 40);
  if (!part || !tag) return null;
  const role = text(report.role, 40);
  const shown = text(report.text, 160);
  return { store, part, tag, ...(role ? { role } : {}), ...(shown ? { text: shown } : {}) };
}
